// import whatsApp icon
import { WhatsAppOutlined } from '@ant-design/icons';

function FutureImplementPlan() {
  const futureFeatures = [
    {
      name: 'ExpiryTracker.jsx',
      description: 'Track product expiry dates with automated alerts',
      benefit: 'Reduce waste and ensure food safety',
    },
    {
      name: 'WasteLog.jsx',
      description: 'Record and analyze inventory waste',
      benefit: 'Identify cost-saving opportunities',
    },
    {
      name: 'RecipeCosting.jsx',
      description: 'Calculate menu item costs based on current inventory prices',
      benefit: 'Better pricing and profit analysis',
    },
    {
      name: 'SupplierManagement.jsx',
      description: 'Manage supplier information and performance metrics',
      benefit: 'Streamline purchasing process',
    },
    {
      name: 'Custom Features',
      description: 'Tailored solutions based on your specific needs',
      benefit: 'Perfect fit for your business workflow',
    },
  ];

  return (
    <div className="p-6 max-w-4xl mx-auto">

      <h1 className="text-3xl font-bold mb-6 text-blue-600">Future Development Roadmap</h1>
      <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-gray-700">
        <p className="text-lg text-gray-300 mb-6">
          The following features can be implemented based on your business needs and budget.
          Let us know which ones you&#39;d like to prioritize.
        </p>

        <div className="space-y-4">
          {futureFeatures.map((feature) => (
            <div key={feature.name} className="p-4 bg-gray-800/50 rounded-lg border-l-4 border-amber-500">
              <h3 className="text-xl font-semibold text-amber-400">{feature.name}</h3>
              <p className="text-gray-300 mt-1">{feature.description}</p>
              <p className="text-green-400 mt-2 text-sm">
                <span className="font-medium">Business Benefit:</span>
                {' '}
                {feature.benefit}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 p-4 bg-blue-900/20 rounded-lg">
          <h3 className="text-lg font-semibold text-white mb-2">Next Steps</h3>
          <p className="text-gray-300">
            Contact our team to discuss implementation timelines and costs for these features.
          </p>
          <button
            type="button"
            className="mt-3 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition"
            // Add whatsApp functionality here
            onClick={() => window.open('https://wa.me/8801737378258', '_blank')}
          >
            <WhatsAppOutlined className="inline-block mr-2 bg-green-800" />
            Request Feature Consultation
          </button>
        </div>
      </div>
    </div>
  );
}

export default FutureImplementPlan;
